module.exports = __webpack_public_path__ + "img/new_fangxinhaibao.3e411e36.png";